import axios from 'axios';

export const GET_USERS_ACTIONS = '/userActivitiesLog/getUserActivitiesLogs';
export const GET_USERS_ACTIONS_EXCEL = '/userActivitiesLog/getUserActivitiesLogsForExcelFile';
export const LOG_USER_ACTION = '/userActivitiesLog/logUserActivity';

export function getUsersActions(queryParams, cancellationHandlers) {
  return axios.get(GET_USERS_ACTIONS, {params: queryParams, ...cancellationHandlers});
}

export function getUserActivitiesLogsForExcelFile(queryParams) {
  return axios.get(GET_USERS_ACTIONS_EXCEL, {params: queryParams});
}

export function logUserAction(page, subject, action, payload, result) {
  return axios.post(LOG_USER_ACTION, {page, subject, action, payload, result});
}